import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const ScrollableContainer = styled(Box).attrs({
  px: 16,
  py: '10px',
  mt: 33,
})`
  border: ${p =>
    `1px solid ${
      p.errorBorder
        ? p.theme.colors.lightDanger
        : p.theme.colors.heavyLineOutline
    }`};
  border-radius: 5px;
  overflow: scroll;
  height: 190px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
`;

export const RowText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  display: inline-flex;
  flex: 1 1 auto;
`;

export const SectionTitle = styled(Text).attrs({
  size: 'small',
  fontWeight: 'bold',
  color: 'primaryText',
  my: 10,
})``;
